import React from "react";
import { NavLink } from "react-router-dom";
import userIcon from "../../assets/icons/profile.png";
import myservice from "../../assets/icons/my-service.png";
import logout from "../../assets/icons/logout.png";
import myquotes from "../../assets/icons/myquotes.png";
import ongoing from "../../assets/icons/ongoing.png";
// import feedbackIcon from "../../assets/images/icons/reviews-menu.png";
import { useUser } from "../context/UserContext";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
const SideBar = () => {
  const navigate = useNavigate();

  const { setAuthentication } = useUser();
  const handleLogout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("userRole");
    setAuthentication(null);
    navigate("/");
    window.location.reload();
  };
  return (
    <div className="my-account-sidebar">
      <ul className="sidebar-list">
        <li>
          <NavLink to="profile">
            <img src={userIcon} alt="" />
            My Profile
          </NavLink>
        </li>
        <li>
          <NavLink to="ongoing-booking">
            <img src={myservice} alt="" />
            Ongoing Bookings
          </NavLink>
        </li>
        <li>
          <NavLink to="complete-booking">
            <img src={ongoing} alt="" />
            Completed Bookings
          </NavLink>
        </li>
        <li>
          <NavLink to="/" onClick={handleLogout}>
            <img src={logout} alt="" /> Logout
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default SideBar;
